import React from "react"

import ModalHelper from "../../../utils/modalHelper";

const LinkCTAModal = ({buttonProps, withClass}) => {
  let modal = buttonProps.modal[0];
  buttonProps.cta_type = "link_cta"

  return ( 
    <div className="link-cta-button-wrapper">
      {modal ? <ModalHelper buttonProps={buttonProps} withClass={withClass}/> : null}
    </div>
  );
}
 
export default LinkCTAModal;